import React from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {connect} from 'react-redux'
import R from 'ramda'

import toggleEstateList from '../actions/toggleEstateList'

import getCurrentQuery from '../utils/getCurrentQuery'

import smoothScroll from '../utils/smoothScroll.js'

const ModifyButton = ({onShowFilters})=> {
  const query = getCurrentQuery()
  const nbTypes = R.length(query.features.estateTypes) 

  return <div id="modify-button" style={{visibility:'visible', position:'fixed', zIndex:'1000', top:'-9999px', left:'-9999px', backgroundColor:'red'}}>
          <div>
            <a onClick={onShowFilters} className="btn btn-primary btn-sm" style={{textTransform: "initial", padding: "5px 5px"}}> 
              <FormattedMessage id="Modify search" defaultMessage="Modify query"/>
            </a>
          </div>
        </div>

}

ModifyButton.propTypes = {
  onShowFilters: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return { }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onShowFilters: _ => {
      {/*dispatch(toggleEstateList())*/}
			smoothScroll(0);
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifyButton)



/** WEBPACK FOOTER **
 ** ./app/components/ModifyButton.jsx
 **/